import {
    ADD_GROUP_REQUEST,
    ADD_GROUP_FAILURE,
} from '../constants/add_group.constants';

const initialState = {
    User_group_create_table: {
        isAdded: false,
        error: null,
    },
};

export const User_group_create = (state = initialState, action) => {
    switch (action.type) {
    case ADD_GROUP_REQUEST:
        return {
            ...state,
            User_group_create_table: {
                ...state.User_group_create_table,
                isAdded: true,
            },
        };
    case ADD_GROUP_FAILURE:
        return {
            ...state,
            User_group_create_table: {
                ...state.User_group_create_table,
                error: action.error,
            },
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_group_create/redux/reducers/add_group.reducers.js